import React from 'react'
import Select from 'react-select'

const MultiSelectDropdown = ({ value, name, options, onChange }) => {
    return (
        <Select
            value={value || ""}
            isMulti
            name={name}
            onChange={onChange}
            id={name}
            options={options.map(item => ({ label: item.name, value: item.id }))}
            className="basic-multi-select"
            classNamePrefix="select"
        />
    )
}

export default MultiSelectDropdown